import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

export default class extends Controller {
  static targets = ['canvas']

  connect() {
    let canvas = this.canvasTarget
    let chartData = JSON.parse(canvas.getAttribute('data-chart-data'))
    let ctx = this.canvasTarget.getContext('2d')
    const isDarkMode = document.documentElement.getAttribute('data-bs-theme') === 'dark'
    const labelColor = isDarkMode ? '#ffffff' : undefined
    new Chart(ctx, {
      data: {
        datasets: [{
          type: 'line',
          label: chartData.label,
          data: chartData.line_graph,
          yAxisID: 'y'
        }],
        labels: chartData.dates
      },
      options: {
        // Don't let the graph height shrink to a tiny size if the viewport width is small
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: chartData.title,
            color: labelColor
          }
        },
        scales: {
          y: {
            display: true,
            position: 'left',
            ticks: {
              color: labelColor,
              // Don't show negative scale on y-axis when all counts are zero
              beginAtZero: true,
              // Don't show non-integer tick values on the y-axis
              callback: function(value) {
                if (value % 1 != 0) { return }

                let displayValue = Intl.NumberFormat('en-US', {
                  notation: 'compact',
                  maximumFractionDigits: 1
                }).format(value)

                return displayValue
              }
            },
            min: 0,
            grid: {
              display: false
            },
            title: {
              display: true,
              text: chartData.y_title,
              color: labelColor
            }
          },
          x: {
            ticks: {
              color: labelColor
            },
            grid: {
              display: false
            },
            title: {
              display: chartData.x_title,
              text: chartData.x_title,
              color: labelColor
            }
          }
        }
      }
    });
  }
}
